import { useEffect, useState } from "react";
import { Eye, Loader2, ShieldCheck } from "lucide-react";
import { api, formatError } from "@/lib/api";

export const LetterViewer = ({ mailId, watermark }) => {
  const [url, setUrl] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => () => url && URL.revokeObjectURL(url), [url]);

  const open = async () => {
    setLoading(true);
    setError("");
    try {
      const { data } = await api.get(`/mail/${mailId}/document`, { responseType: "blob" });
      setUrl(URL.createObjectURL(new Blob([data], { type: "application/pdf" })));
    } catch (e) {
      setError(formatError(e));
    } finally {
      setLoading(false);
    }
  };

  if (!url) {
    return (
      <div className="rounded-xl border border-dashed border-slate-300 dark:border-slate-700 p-10 text-center bg-slate-50 dark:bg-slate-900/40">
        <ShieldCheck className="mx-auto text-emerald-600" />
        <p className="mt-3 text-sm text-slate-600 dark:text-slate-300">Opening or downloading the letter is recorded in the audit trail.</p>
        <button data-testid="open-letter-btn" onClick={open} disabled={loading} className="mt-5 inline-flex items-center gap-2 px-5 py-2.5 rounded-full bg-slate-900 text-white dark:bg-white dark:text-slate-900 text-sm font-semibold hover:bg-emerald-600 dark:hover:bg-emerald-500 transition-colors disabled:opacity-60">
          {loading ? <Loader2 size={16} className="animate-spin" /> : <Eye size={16} />} Open letter
        </button>
        {error && <p data-testid="letter-error" className="mt-3 text-sm text-red-600">{error}</p>}
      </div>
    );
  }
  return (
    <div className="relative rounded-xl overflow-hidden border border-slate-200 dark:border-slate-800 bg-slate-100" onContextMenu={(e) => e.preventDefault()}>
      <iframe data-testid="letter-iframe" title="Letter" src={`${url}#toolbar=0&navpanes=0`} className="w-full h-[75vh]" />
      <div className="pointer-events-none absolute inset-0 flex items-center justify-center">
        <p className="rotate-[-24deg] text-slate-900/10 font-display font-bold text-3xl sm:text-5xl whitespace-nowrap select-none">{watermark}</p>
      </div>
    </div>
  );
};
